/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LongArrowRight/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function LongArrowRight({
  children,
  viewPath = "/DesignSystem/Svgs/LongArrowRight",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 16,
  height = 16,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "none",
  stroke = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="LongArrowRight.Svg"
  data-view-path={viewPath}
 viewBox="0 0 16 16"
 overflow="visible"
 style={{'--as-1-Z1iXDVT': alignSelf,'--mt-2-Z1iXDVT': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1iXDVT': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1iXDVT': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1iXDVT': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1iXDVT': opacity,'--w-10-Z1iXDVT': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1iXDVT': typeof height === 'number' ? `${height}px` : height,'--a-7-Z1iXDVT': isAnimated ? animation : "none",'--sd-8-Z1iXDVT': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1iXDVT': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="LongArrowRight.SvgPath"
  data-view-path={viewPath}
 strokeWidth={2}
 strokeMiterlimit={10}
 d="M8 3.2L12.8 8 8 12.8M2.2 8h10.6"
 style={{'--f-12-Z1iXDVT': fill,'--s-13-Z1iXDVT': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}